import { Modal, Button } from "antd";
import React from "react";

interface RetryEvaluationModalProps {
  showEvaluation: boolean;
  containerRef: React.RefObject<HTMLDivElement> | null;
  handleRetryEvaluation: () => void;
}
const RetryEvaluationModal: React.FC<RetryEvaluationModalProps> = ({
  showEvaluation,
  containerRef,
  handleRetryEvaluation,
}) => {
  return (
    <div>
      <Modal
        title="Retry Evaluation ?"
        open={showEvaluation}
        onOk={handleRetryEvaluation}
        okText={"Retry Evaluation"}
        centered
        maskClosable={false}
        closeIcon={false}
        getContainer={() => containerRef?.current!}
        footer={[
          <Button key="retry" type="primary" onClick={handleRetryEvaluation}>
            Retry Evaluation
          </Button>,
        ]}
      >
        <p>
          Failed to evaluate the responses of the interview round. Please retry
          the evaluation.
        </p>
      </Modal>
    </div>
  );
};

export default RetryEvaluationModal;
